import { render, staticRenderFns } from "./FourthBlockPrices.vue?vue&type=template&id=04bbc6b3"
import script from "./FourthBlockPrices.vue?vue&type=script&lang=js"
export * from "./FourthBlockPrices.vue?vue&type=script&lang=js"
import style0 from "./FourthBlockPrices.vue?vue&type=style&index=0&id=04bbc6b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports